<template>
  <div ref="select" class="c-select" @click="toggleDropdown">
    <slot v-if="$slots.prefix" name="prefix" />
    <div class="flex-grow truncate">
      <span v-if="!selectValue" class="c-select__placeholder">{{ props.placeholder || 'Select option' }}</span>
      <span v-else-if="display">{{display}}</span>
      <span v-else>{{ selectValue }}</span>
    </div>
    <div class="pl-12">
      <se-icon name="chevron-down" :size="20" />
    </div>
    <div class="c-select__options" :class="{ 'is-open': isOpen }">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useSlots } from 'vue';
import SeIcon from '../icon/Icon';

const props = defineProps<{
  modelValue: string,
  placeholder?: string,
  error?: boolean,
}>();

const emit = defineEmits<{(e: 'update:modelValue', value: string): void}>();

const slots = useSlots();

const selectValue = computed({
  get() {
    return props.modelValue;
  },
  set(value: string) {
    emit('update:modelValue', value);
  },
});

const display = computed(() => {
  let selectedOption = null;
  if (slots.default) {
    const options = slots.default();
    selectedOption = options.find((o) => o.props?.value === selectValue.value);
  }

  return selectedOption?.props?.label;
});

const setValue = (value: string) => {
  selectValue.value = value;
};

const isOpen = ref<boolean>(false);
const select = ref<any>(null);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

// const handleClickOutside = (event: any) => {
//   if (select.value && !select.value.contains(event.target)) {
//     isOpen.value = false;
//   }
// };
//
// onMounted(() => {
//   document.addEventListener('click', handleClickOutside);
// });
//
// onUnmounted(() => {
//   document.removeEventListener('click', handleClickOutside);
// });

defineExpose({
  selectValue,
  setValue,
});
</script>

<script lang="ts">
export default {
  name: 'SeSelect',
};
</script>
